import React, { useEffect } from 'react';
import { inject } from 'mobx-react';
import { observer } from 'mobx-react-lite';
import { Route, Switch } from 'react-router-dom';
import Theme from '@containers/common/theme';
import NewHeader from '@containers/newCreateRequest/menu';
import CreateSteps from '@containers/newCreateRequest/stepsItems';
import { HomeBusiness } from '@business/newCreateRequest/common/home';
import NewRSPIndex from '@containers/newCreateRequest';
import { isIH } from '@common/utils/userProfile';
import Header from '@containers/common/header';
import CopilotIndex from '@containers/common/copilotIndex';
var NewMainLayout = inject(HomeBusiness)(observer(function (props) {
    var setPageTitle = props.setPageTitle, getCurrentUser = props.getCurrentUser, needCopilotFixedButton = props.needCopilotFixedButton;
    useEffect(function () {
        setPageTitle('');
        getCurrentUser();
    }, []);
    return React.createElement("div", { className: "body_wrapper_light_background" },
        React.createElement(Theme, null,
            isIH() ? React.createElement(Header, null) : React.createElement(NewHeader, null),
            React.createElement(Switch, null,
                React.createElement(Route, { exact: true, path: "/newRequest/home", component: NewRSPIndex }),
                React.createElement(Route, { exact: true, path: "/newRequest/create", component: CreateSteps })),
            needCopilotFixedButton && React.createElement(CopilotIndex, { needFixedButton: true })));
}));
export default NewMainLayout;
